/**
 * Language persistence wiring.
 *
 * When a signed-in user switches language in-app, persist the choice to their
 * profile (`PATCH /v1/users/:uuid`). The backend also pushes it to FusionAuth
 * `preferredLanguages`. Anonymous switches (e.g. on the landing page, before
 * login) are ignored. Call `initLanguageSync()` once at app startup.
 */
import { setLanguagePersistence } from '@infra/i18n';
import { getUserPublicId } from '@infra/auth';
import * as usersApi from '../core/api/users';

export function initLanguageSync(): void {
  setLanguagePersistence(async (language: string) => {
    const uuid = getUserPublicId();
    // Not signed in → nothing to persist (the choice still lives in localStorage).
    if (!uuid) return;
    await usersApi.updateProfile(uuid, { language });
  });
}
